import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice d'aire circulaire";
const DESCRIPTION =
  "Resolvez vos calculs mathematiques en ligne avec une methode simple et un resultat immediat.";
const KEYWORDS =
  "calculatrice mathematiques, formule, calcul rapide, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/circle-calculator/";
function CircleCalculator() {
  const [radius, setRadius] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!radius) {
        setError("Veuillez entrer un rayon");
        setResult(null);
        return;
      }
      const r = parseFloat(radius);
      if (r <= 0) {
        setError("Le rayon doit être positif");
        setResult(null);
        return;
      }
      const area = Math.PI * r * r;
      const circumference = 2 * Math.PI * r;
      const diameter = 2 * r;
      setResult({
        area: area.toFixed(2),
        circumference: circumference.toFixed(2),
        diameter: diameter.toFixed(2)
      });
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de cercle calcule l'aire, la circonférence et le diamètre
                  d'un cercle à partir de son rayon.
                </p>
                <ul>
                  <li>Aire du cercle: A = π × r²</li>
                  <li>Circonférence: C = 2π × r</li>
                  <li>Diamètre: d = 2 × r</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Rayon (m)
                      </label>
                      <input
                        type="number"
                        value={radius}
                        onChange={(e) => setRadius(e.target.value)}
                        placeholder="Entrez le rayon"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>Aire: <strong>{result.area} m²</strong></p>
                      <p>Circonférence: <strong>{result.circumference} m</strong></p>
                      <p>Diamètre: <strong>{result.diameter} m</strong></p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce qu'un cercle ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Un cercle est une figure plane dont tous les points du bord sont
                        équidistants du centre. Les formules principales sont :
                        Aire = π × r², Circonférence = 2 × π × r, avec π ≈ 3,14159.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Comment calculer le rayon ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Depuis le diamètre : r = d / 2.
                        Depuis la circonférence : r = C / (2π).
                        Depuis l'aire : r = √(A / π).
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default CircleCalculator;
